import React from 'react';

import Img from 'retired/Img';
import H3 from 'retired/H3';
import { lighterGray } from 'utils/color-styles';

export const SummaryCardHeader = ({ headerImage, title }: SummaryCardHeaderProps) => (
  <div
    style={{
      display: 'flex',
      paddingLeft: 16,
      paddingRight: 16,
      alignItems: 'center',
    }}
  >
    <div
      style={{
        borderRadius: '50%',
        backgroundColor: lighterGray,
        width: 40,
        height: 40,
        justifyContent: 'center',
        display: 'flex',
        marginRight: 16,
      }}
    >
      {headerImage && (
        <Img src={headerImage} alt="" style={{ width: 30, height: 30, objectFit: 'contain' }} />
      )}
    </div>
    <H3 style={{ lineHeight: 0.5 }}>{title}</H3>
  </div>
);
interface SummaryCardHeaderProps {
  headerImage?: string;
  title: string;
}
